export default __webpack_public_path__ + "static/media/igem_white.6bc7bac5.svg";